import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { META_DESCRIPTION } from '@/utils/constants/seo/meta';
import { getAbsolutePath, seminarListPath } from '@/utils/router/links';
import { REGISTRATION_TYPE_SEMINAR_LIST } from '../../../define/consts/registration';
import { propArrayShape, propArrayStr, propBool, propChildren, propFunc, propStr, } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import useAnalytics from '../../../helpers/use/analytics/useAnalytics';
import { useRegistrationCta } from '../../../helpers/use/useRegistrationCta';
import Layout from '../../Layout';
import Breadcrumb from '../../Layout/Breadcrumb';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import FullScreenImageViewerModal from '../../Ui/Modal/FullScreenModal/ImageViewer/FullScreenImageViewerModal';
import RegistrationAlertModal from '../../Ui/Modal/RegistrationAlertModal';
import RegistrationCompleteModal from '../../Ui/Modal/RegistrationCompleteModal';
import RegistrationCta from '../../Ui/Registration/RegistrationCta';
const registrationCtaScrollName = 'column_registration_form';
const title = 'セミナー一覧｜PROFFIT';
const description = META_DESCRIPTION.seminarList();
const ClientSeminarListLayout = (props) => {
    const { breadcrumbItems, children, hideDocumentModal, hideRegistrationModal, images, isGuestUser, isShowDocumentModal, isShowRegistrationModal, mainClassName, onChangeDocumentImage, } = props;
    const { onClickRegistration } = useAnalytics.useColumn();
    const { hideModal, isShowForm, isShowModal, onSubmitAfter } = useRegistrationCta.useRegistrationCtaForm(registrationCtaScrollName, isGuestUser, onClickRegistration);
    return (_jsxs(Layout, Object.assign({ mainClassName: mainClassName }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: 'article', property: 'og:type' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: getAbsolutePath(seminarListPath()), property: 'og:url' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(Breadcrumb, { lists: breadcrumbItems }), children, _jsx(RegistrationAlertModal, { isShow: isShowRegistrationModal, onClickOther: hideRegistrationModal, registrationType: REGISTRATION_TYPE_SEMINAR_LIST }), _jsx(RegistrationCta, { isShow: isShowForm, onSubmitAfter: onSubmitAfter, registrationType: REGISTRATION_TYPE_SEMINAR_LIST, scrollName: registrationCtaScrollName }), _jsx(RegistrationCompleteModal, { hideModal: hideModal, isShow: isShowModal, timeout: 300 }), _jsx(FullScreenImageViewerModal, { hideFullModal: hideDocumentModal, images: images, isShow: isShowDocumentModal, onChangeSlideImage: onChangeDocumentImage })] })));
};
ClientSeminarListLayout.propTypes = {
    breadcrumbItems: propArrayShape().isRequired,
    children: propChildren().isRequired,
    hideDocumentModal: propFunc().isRequired,
    hideRegistrationModal: propFunc().isRequired,
    images: propArrayStr(),
    isGuestUser: propBool().isRequired,
    isShowDocumentModal: propBool().isRequired,
    isShowRegistrationModal: propBool().isRequired,
    mainClassName: propStr(),
    onChangeDocumentImage: propFunc().isRequired,
};
ClientSeminarListLayout.defaultProps = {
    images: [],
    mainClassName: '',
};
const enhance = compose(AuthenticationHoc({
    isNotRequireCheckProfile: true,
}));
export default enhance(ClientSeminarListLayout);
